// extracted by mini-css-extract-plugin
export var card = "address-card-module--card--c6e71";
export var cardActionBox = "address-card-module--card-action-box--cb24a";
export var cardContent = "address-card-module--card-content--7f10e";
export var cardTitle = "address-card-module--card-title--6dfa0";
export var clickable = "address-card-module--clickable--6fca5";
export var selected = "address-card-module--selected--008fb";